<template>
  <div class="tab-body">
    <div class="search">
      <el-form ref="form" :model="searchParams" label-width="80px">
        <el-row>
  
          <el-col :span="4">
            <el-form-item label="标题">
              <el-autocomplete class="inline-input" v-model="searchParams.title" :fetch-suggestions="querySearch"
                placeholder="请输入内容" @select="handleSelect"></el-autocomplete>
            </el-form-item>
          </el-col>

          <el-col :span="5">
            <el-form-item label="状态">
              <el-select v-model="state" @change="searchState" placeholder="请选择">
                <el-option v-for="i in ['未读', '已读', '全部']" :key="i" :label="i" :value="i">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="5">
            <el-form-item label="班级">
              <el-select v-model="searchParams.cname" @change="search()" placeholder="请选择班级">
                <el-option v-for="item in clazzList" :key="item.id" :label="item.name" :value="item.name"></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <el-form-item label="姓名">
              <el-input v-model="searchParams.sname" @click="search"></el-input>
            </el-form-item>
          </el-col>
          <el-collapse-transition>
            <div v-if="isShowMoreSearch">
              <!--隐藏区域-->
            </div>
          </el-collapse-transition>
          <div class="search-btn">
            <el-button @click="search()">搜索</el-button>
            <el-button @click="clearSearchVal">重置</el-button>

          </div>
        </el-row>
      </el-form>
    </div>
    <div class="operator">
      <!-- 添加 -->
      <!-- <el-button type="primary" icon="el-icon-plus" @click="toSave()"
        >添加</el-button
      > -->
      <el-button type="primary" size="mini" icon="el-icon-finished" v-has-permission-code-and="'0040004000000000'"
        @click="batchUpdateReadstAndToRate()">批量评分</el-button>
      <el-button type="danger" v-has-permission-code-and="'0040004000000000'" size="mini" icon="el-icon-delete"
        @click="batchRemove()">批量删除</el-button>
    </div>
    <div class="dataTable autoFlex" v-if="listData">
      <el-table class="table" :data="listData.records" stripe border height="auto" @selection-change="selectionChange"
        v-loading="listLoading">
        <el-table-column type="selection" width="55" fixed="left"></el-table-column>
        <el-table-column prop="subtime" label="学习时间"> </el-table-column>
        <el-table-column prop="title" label="名称/标题">
          <template slot-scope="scope">
             {{ scope.row.name }}/{{ scope.row.title }}
          </template>
        </el-table-column>
        <el-table-column prop="sname" label="学生名字"></el-table-column>
        <el-table-column prop="cname" label="班级名字"></el-table-column>
        <el-table-column prop="tname" label="老师"></el-table-column>
        <el-table-column prop="course" label="课程"></el-table-column>
        <el-table-column prop="score" width="145" label="评分">
          <template slot-scope="scope">
            <el-rate v-model="scope.row.score * 1" :colors="colors" :disabled="true">
            </el-rate>
          </template>
        </el-table-column>

        <el-table-column prop="chetime" width="145" label="老师查看"> </el-table-column>
        <el-table-column prop="readst" width="65" label="已读">
          <template slot-scope="scope">
            <el-switch v-if="scope.row.readst == 1" :disabled="true" :value="true"></el-switch>
            <el-switch v-if="scope.row.readst == 0" :disabled="false" @change="updateReadst(scope.$index, scope.row)">
            </el-switch>
          </template>
        </el-table-column>
        <el-table-column label="操作" fixed="right" width="200px">
          <template slot-scope="scope">
            <div class="dataTable-operator">
              <el-button size="mini" v-has-permission-code-and="'0040004000000000'"
                @click="toDetail(scope.$index, scope.row)"> {{ scope.row.score ? '详情' : '评分' }}</el-button>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="pageBar">
        <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="listData.total"
          :page-size="page.size" :current-page="page.current" :layout="this.$constant.page.layout"
          :page-sizes="this.$constant.page.pageSizes"></el-pagination>
      </div>
    </div>
    <edit ref="edit"></edit>
    <edit2 ref="edit2"></edit2>
  </div>
</template>
<script>
import edit from "./edit.vue";
import edit2 from "./edit2.vue";
import api from "@/api/study/feedback/feedback.js";
import qlhTable from "@/components/qlhTable/qlhTable.vue";
import qlhTableColumn from "@/components/qlhTable/qlhTableColumn.vue";
export default {
  name: "feedback",
  components: {
    edit,
    edit2,
    qlhTable,
    qlhTableColumn,
  },
  data() {
    return {
      state: "未读",
      colors: { 3: "#99A9BF", 5: "#FF9900" },
      checked: true,
      searchParams: {},
      isShowMoreSearch: false,
      listLoading: false,
      listData: [],
      selected: [],
      page: new this.$constant.pageObj(),
      postsList: [],
      clazzList: {},
      dropDatas:[ { "value": "【面试准备ALL】" }],
      dftClz: false,
    };
  },
  watch: {
    "searchParams.sname": function (newVal, oldVal) {
      this.searchParams.sname = newVal;
      this.search();
    },
  },
  methods: {
    querySearch(queryString, cb) {
      var listDatas = this.dropDatas;
      var results = queryString ? listDatas: listDatas;
      // 调用 callback 返回建议列表的数据
      cb(results);
    },
    handleSelect(item) {
      this.state='全部'
      this.searchParams.readst = undefined;
      this.list();
    },
    content: function (content) {
      this.$alert(content, "详情", {
        dangerouslyUseHTMLString: true,
      });
    },

    //获取数据
    list() {
      this.listLoading = true;
      let params = this.$utils.merger(this.searchParams, this.page);
      api.list(params, (response) => {
        this.listData = response.data;
        this.listLoading = false;
      });
    },
    //获取班级
    listCname() {
      this.listLoading = true;

      api.listCname({}, (response) => {
        this.postsList = response.data;
        this.clazzList = response.data.clazzList;
        this.listLoading = false;
      });
    },
    //去添加
    toSave() {
      this.$refs.edit2.open({}, "添加", false);
    },
    //去评分
    toRate(index, row) {
      let editParameter = {
        id: row.id,
      };
      // console.log(editParameter); return
      this.$refs.edit2.open(editParameter, "评分");
    },
    updateReadst(index, row) {
      let parameter = {
        id: row.id,
      };
      api.readst2(
        parameter,
        (response) => {
          this.$utils.msg.success(response.msg);
          this.list();
        },
        (response) => {
          this.$utils.msg.warning(response.msg);
        }
      );
    },
    //批量评分
    batchUpdateReadstAndToRate() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      // let parameter = {
      //   ids: this.selected, //这是一个ID数组
      // };
      let IdsArr = []; //选中的所有学生的ID   {id:id}[]
      this.selected.forEach((IDitem) => {
        IdsArr.push({ id: IDitem });
      });
      // console.log('feedback,selected，已选择的id,批量已读按钮', this.selected);
      this.$refs.edit2.open(IdsArr, "批量评分");
      return;

    },
    //去详情
    toDetail(index, row) {
      let detailParameter = {
        id: row.id,
      };
      this.$refs.edit2.open(detailParameter, "详情", true);
    },
    //删除
    remove(index, row) {
      let parameter = {
        ids: row.id,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          parameter,
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //批量删除
    batchRemove() {
      if (!this.selected || this.selected.length == 0) {
        this.$utils.msg.info("请选择至少一行");
        return;
      }
      let parameter = {
        ids: this.selected,
      };
      this.$utils.confirm.warning("提示", "确定删除吗？", () => {
        api.remove(
          {
            ids: this.selected,
          },
          (response) => {
            this.$utils.msg.success(response.msg);
            this.list();
          },
          (response) => {
            this.$utils.msg.warning(response.msg);
          }
        );
      });
    },
    //改变选择项
    selectionChange(val) {
      //清空
      this.selected = [];
      for (let item of val) {
        this.selected.push(item.id);
      }
    },
    //改变每页显示数量
    sizeChange(val) {
      this.page.size = val;
      this.list();
    },
    //改变现在的页码
    currentChange(val) {
      this.page.current = val;
      this.list();
    },

    //搜索状态
    searchState() {
      if (this.state == "未读") {
        this.searchParams.readst = 0;
      }
      if (this.state == "已读") {
        this.searchParams.readst = 1;
      }
      if (this.state == "全部") {
        this.searchParams.readst = undefined;
      }
      this.list();
    },
    //搜索按键
    search() {
      if (this.searchParams.cname) {
        // 写入
        this.$caches.dftClz.set(this.searchParams.cname);
      } else {
        this.$caches.dftClz.remove();
      }
      this.list();
    },
    //清空搜索框
    clearSearchVal() {
      this.searchParams = { readst: 0 };
      this.state = "未读"
      this.$caches.dftClz.remove();
      this.list();
    },
    // 显示班级
    showClz() {
      let dftClz = this.$caches.dftClz.get();
      if (dftClz) {
        this.dftClz = dftClz;
        this.searchParams = { cname: dftClz };
      }
    },
  },
  mounted() {
    this.showClz();
    this.list();
    this.listCname();
  },
};
</script>

<style lang="scss" scoped="scoped">
@import "~common/custom/css/common.scss";
</style>
